import React from "react";
import OliviaDemo from "./OliviaDemo";

function App() {
  return <OliviaDemo />;
}

export default App;
